(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    class SwatchNameUpdater {
    constructor(container) {
      this.container = container;
      this.nameDisplay = this.container.querySelector('.selected-swatch-name');
      this.swatches = this.container.querySelectorAll('input[type="radio"]');

      if (!this.nameDisplay || this.swatches.length === 0) return;

      this.updateName(); // Update nama saat halaman pertama kali dimuat
      this.swatches.forEach((swatch) => {
        swatch.addEventListener('change', this.updateName.bind(this));
      });
    }

    updateName() {
      const selectedSwatch = this.container.querySelector('input[type="radio"]:checked');
      if (selectedSwatch) {
        this.nameDisplay.textContent = selectedSwatch.value;
      }
    }
  }

  // Inisialisasi untuk setiap komponen product-swatches di halaman
  document.querySelectorAll('product-swatches').forEach((container) => {
    new SwatchNameUpdater(container);
  });
  } catch(e) { console.error(e); }
})();

})();
